import env from 'lib/env'
import { cookies } from 'lib/cookies'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

type VersionApi = keyof typeof env.api

export default async function api<T = unknown, D = unknown>(
  route: string,
  params?: AxiosRequestConfig,
  version: VersionApi = 'v3'
) {
  const isV2 = version === 'v2'
  const idToken = cookies.get(isV2 ? 'token' : 'idToken') || ''

  const options: AxiosRequestConfig = {
    method: 'GET',
    baseURL: env.api[version],
    ...params,
    headers: {
      'content-type': 'application/json',
      ...params?.headers
    }
  }

  if (isV2) {
    options.headers.jtoken = idToken
  } else if (idToken) {
    options.headers.authorization = `Bearer ${idToken}`
  }

  // O axios remove o Content-Type quando a requisicao nao tem corpo (ex.: GET).
  // Para manter o header, definimos um data vazio e um transformRequest que nao
  // altera o payload, evitando que o body seja preenchido com "" ou "null".
  if (options.data === undefined) {
    options.data = ''
    options.transformRequest = [data => data]
  }

  const data: AxiosResponse<T, D> = await axios(route, options)

  return data
}
